import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavBar, Checkbox, Toast, Button, Modal, WhiteSpace } from 'antd-mobile';
import { Icon } from 'antd';
import * as services from '../projects/services';
import { createBrowserHistory } from "history";
import './style.less';
const CheckboxItem = Checkbox.CheckboxItem;
const alert = Modal.alert;
let firstShow = true;
const history = createBrowserHistory();
export default class CartList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartlist: [],
            price: 0,
            checklist: [],
            allcheck: true,
            checkprice: 0,
            cnum: 0,
        }
        // this.handleChange=this.handleChange.bind(this);
    }
    componentDidMount() {
        firstShow = false;
        services.GetCartList('正在查询，请稍后').then(value => {
            if (value.status === 0) {
                let checkprice = 0;
                value.result.forEach((data) => {
                    data['checked'] = true;
                    checkprice += parseFloat(data.cartRealPrice) * parseInt(data.buyCount)
                })
                this.setState({ cartlist: value.result, checkprice: checkprice, cnum: value.result.length });
            }
        })
    }
    GetCartList = () => {
        services.GetCartList('').then(value => {
            if (value.status === 0) {
                let checkprice = 0;
                value.result.forEach((data) => {
                    data['checked'] = true;
                    checkprice += parseFloat(data.cartRealPrice) * parseInt(data.buyCount)
                })
                this.setState({ cartlist: value.result, checkprice: checkprice, cnum: value.result.length });
            }
        })
    }
    onChange = (data, index) => {
        let checkprice = 0;
        let cartlist = this.state.cartlist;
        cartlist[index]['checked'] = !this.state.cartlist[index]['checked'];
        this.setState(
            { cartlist: cartlist },
            () => {
                if (this.state.cartlist[index]['checked']) {
                    checkprice = this.state.checkprice + parseFloat(data.cartRealPrice) * parseInt(data.buyCount);
                } else {
                    checkprice = this.state.checkprice - parseFloat(data.cartRealPrice) * parseInt(data.buyCount);
                }
                this.setState({ cartlist: this.state.cartlist, checkprice: checkprice });
            }
        );
    }
    onChange2 = () => {
        let checkprice = 0;
        this.state.cartlist.forEach((data) => {
            data['checked'] = !this.state.allcheck;
            checkprice += parseFloat(data.cartRealPrice) * parseInt(data.buyCount);
        })
        if (this.state.allcheck) {
            checkprice = 0;
        }
        this.setState({ allcheck: !this.state.allcheck, checkprice: checkprice });
    }
    onDelAll(e) {

        let name = '';
        this.state.cartlist.forEach((data) => {
            if (data['checked']) {
                name += data.cartPackName + ',';
            }
        })
        alert('温馨提示', '您确定要删除套餐' + name + '吗？', [
            { text: '再想想', onPress: () => console.log('cancel') },
            {
                text: '确定删除',
                onPress: () => {
                    this.state.cartlist.forEach((data, index) => {
                        if (data['checked']) {
                            this.DelCart(data.packId, data.packType, data.cartId);
                            this.GetCartList();
                        }
                    })
                }
            },
        ])
    }
    handleChange = (mprice, num, event) => {
        let checkprice = 0;
        let cartlist = this.state.cartlist;
        cartlist[num].buyCount = parseInt(event.target.value);


        cartlist.forEach((data) => {
            checkprice += parseFloat(data.cartRealPrice) * parseInt(data.buyCount)
        })
        this.setState({ cartlist: cartlist, checkprice: checkprice, cnum: cartlist.length });



    }
    //新增数量
    onAdd(num, data, e) {

        let cartlist = this.state.cartlist;
        data.buyCount = data.buyCount + 1;
        document.getElementById('realnum' + num).value = data.buyCount;
        cartlist[num] = data;
        let checkprice = 0;
        checkprice = this.state.checkprice + (parseFloat(data.cartRealPrice))
        this.setState({ cartlist: cartlist, checkprice: checkprice });
        this.EditCart(data.packId, data.buyCount, data.packType, data.cartId);
    }
    onDel(num, data, e) {
        let cartlist = this.state.cartlist;
        if (data.buyCount > 1) {
            data.buyCount = data.buyCount - 1;
            document.getElementById('realnum' + num).value = data.buyCount;
            cartlist[num] = data;
            let checkprice = 0;
            checkprice = this.state.checkprice - (parseFloat(data.cartRealPrice))
            this.setState({ cartlist: cartlist, checkprice: checkprice });
            this.EditCart(data.packId, data.buyCount, data.packType, data.cartId);
        } else {

            alert('温馨提示', '已经是最小购买量了,您确定删除该套餐吗？', [
                { text: '取消', onPress: () => console.log('cancel') },
                {
                    text: '删除',
                    onPress: () => {
                        this.DelCart2(data.packId, data.packType, data.cartId);

                    }
                },
            ])

        }
    }
    DelCart(pid, packtype, cartId) {
        //标准套餐
        if (packtype === 1) {
            services.DelCart(pid, '').then(value => {
                if (value.status === 0) {
                } else {
                    Toast.offline(value.message);
                }
            })
        } else {
            services.DelCartCustom(cartId, '').then(value => {
                if (value.status === 0) {
                } else {
                    Toast.offline(value.message);
                }
            })
        }
    }
    DelCart2(pid, packtype, cartId) {
        //标准套餐
        if (packtype === 1) {
            services.DelCart(pid, '').then(value => {
                if (value.status === 0) {
                    Toast.loading(value.message, 1, () => {
                        this.GetCartList();
                    });
                } else {
                    Toast.offline(value.message);
                }
            })
        } else {
            services.DelCartCustom(cartId, '').then(value => {
                if (value.status === 0) {
                    Toast.loading(value.message, 1, () => {
                        this.GetCartList();
                    });
                } else {
                    Toast.offline(value.message);
                }
            })
        }
    }

    EditCart(pid, count, packtype, cartId) {
        let param = { packid: pid, count: count }
        //标准套餐
        if (packtype === 1) {


            services.EditCart(param, '').then(value => {
                if (value.status === 0) {
                 
                } else {
                    Toast.offline(value.message);
                }
            })

        } else {
            let param = { id: cartId, count: count }//购物车id
            services.EditCartcustom(param, '').then(value => {
                if (value.status === 0) {
                 
                } else {
                    Toast.offline(value.message);
                }
            })
        }

    }

    onSelect(num, data, e) {
        e.stopPropagation();
    }
    handleBlur = (e) => {
    
    }
    gopackage = (data, e) => {
      
        if (data.packType === 1) {
            history.push(`/package/details/${data.packId}/0`);
         //   history.push(`/package/details/${data.packId}/${!!data.packName ? data.packName : '测试套餐'}/0`);
            history.go();
        } else {
            Toast.info('我是自定义套餐，暂无套餐信息', 2);
        }
    }

    render() {
        const { cartlist } = this.state;
        const tabUrl = require('../../res/images/bar_home_on.png');
        return <div style={this.state.cnum === 0 && firstShow === false ? { minHeight: document.documentElement.clientHeight, backgroundColor: '#ffffff' } : {}}>

            <div style={{ display: "block", width: "100%", position: "fixed", top: "0px", zIndex: "999" }}>
                {
                    <NavBar
                        mode="light"
                        icon={<Icon type="left" />}
                        onLeftClick={() => {
                            history.push("/package");
                            history.go();
                        }}

                        rightContent={[
                           cartlist.length > 0 ? <Icon key="0" type="delete" onClick={this.onDelAll.bind(this)} /> : 
                           <img src={tabUrl} alt="" key="1" style={{ width: '25px', height: '25px' }} onClick={()=>
                            {
                                history.push('/');
                                history.go();
                            }} />,

                             ]}

                    
                >购物车</NavBar>
            }
            </div>
            <div className="shopping">
                <div className='cart'>
                    {
                        this.state.cartlist.length <= 0 ? '' :
                            this.state.cartlist.map((data, index) => (
                                <div key={index}>
                                    <div className="line"></div>
                                    <div className="cartbox" >
                                        <CheckboxItem key={'check' + index} checked={data.checked} onChange={() => this.onChange(data, index)} ></CheckboxItem>
                                        <div className="img" onClick={this.gopackage.bind(this, data)} >
                                            {
                                                data.picturePack === null ? <img src={require('../../res/images/h_zw.jpg')} alt="" /> : <img src={data.picturePack.length === 0 ? require('../../res/images/h_zw.jpg') : data.picturePack[0].picpath} alt="" />
                                            }

                                        </div>
                                        <div className="text" onClick={this.gopackage.bind(this, data)}><div className="name"> {data.cartPackName}</div><div className="hname">{data.mcName}</div><div className="hprice">{data.cartRealPrice}</div></div>
                                        <div className="operate" >
                                            <Icon type="plus" style={{ fontSize: '12px' }} onClick={this.onAdd.bind(this, index, data)} />
                                            <input type="text" id={'realnum' + index} ref="Dom" className="num" defaultValue={data.buyCount} onChange={this.handleChange.bind(this, data.cartRealPrice, index)}
                                            />
                                            <Icon type="minus" style={{ fontSize: '12px', }} onClick={this.onDel.bind(this, index, data)} />
                                        </div>
                                    </div>
                                </div>
                            ))
                    }
                    {
                        this.state.cnum === 0 && firstShow === false ?

                            <div className="nothing">
                                <img alt='' src={require('../../res/images/gwck.png')} />
                                <p>当前购物车为空</p>
                                <Link to='/package'>前往套餐列表页寻找套餐</Link>
                            </div>
                            : ''
                    }

                </div>
                {
                    this.state.cnum === 0 && firstShow === false ? '' :
                        <div className="footer">
                            <div className="footerbox footerbox2">
                                <div className="fbigBtn settlementbox">
                                    <CheckboxItem checked={this.state.allcheck} onChange={() => this.onChange2()}  >全选，总价<span className="hprice">{(this.state.checkprice).toFixed(2)}</span></CheckboxItem></div>
                                <Button className="fbigBtn settlementBtn" onClick={() => {
                                    let cmbox = this.state.cartlist.filter(item => item.checked === true);
                                    localStorage.setItem('cartlist', JSON.stringify(cmbox));
                                    history.push('/shopping/account');
                                    history.go();
                                }
                                } >结算</Button>
                            </div>
                        </div>
                }
            </div>
            <WhiteSpace size="lg" />
        </div >
    }
}
